import { ProjectStageResponse, ProjectStageRequest } from '@business/entities/project/ProjectStageResponse';
import { Endpoint } from '../endpoint';

export function fetchProjectStages() {
  return Endpoint.get<ProjectStageResponse[]>('@gc/project/board/stages');
}

export function fetchProjectStage(id: string) {
  return Endpoint.get<ProjectStageResponse>(`@gc/project/board/stage/${id}`);
}

export function createProjectStage(data: ProjectStageRequest) {
  return Endpoint.post<ProjectStageResponse>(`@gc/project/board/stage`, { data });
}

export function updateProjectStage(id: string, data: ProjectStageRequest) {
  return Endpoint.patch<ProjectStageResponse>(`@gc/project/board/stage/${id}`, { data });
}

export function deleteProjectStage(id: string) {
  return Endpoint.delete<void>(`@gc/project/board/stage/${id}`);
}
